import { z } from 'zod';

/**
 * The model's request to turn on tools on an already-connected toolkit.
 *
 * The toolkit and slugs are all it may say. The resume grants exactly those
 * slugs from the persisted pause, never from the client's response.
 */
export const enableExternalToolsInputSchema = z.object({
  toolSlugs: z.array(z.string().min(1)).min(1),
  toolkit: z.string().min(1),
});

export const enableExternalToolsOutputSchema = z.object({
  status: z.enum(['enabled', 'dismissed']),
  toolSlugs: z.array(z.string().min(1)),
  toolkit: z.string().min(1),
});

export type EnableExternalToolsInput = z.infer<typeof enableExternalToolsInputSchema>;
export type EnableExternalToolsOutput = z.infer<typeof enableExternalToolsOutputSchema>;

export function parseEnableExternalToolsInput(input: unknown): EnableExternalToolsInput | null {
  const parsed = enableExternalToolsInputSchema.safeParse(input);
  if (!parsed.success) return null;
  const toolkit = parsed.data.toolkit.trim().toLowerCase();
  const toolSlugs = [...new Set(parsed.data.toolSlugs.map(slug => slug.trim()).filter(Boolean))];
  if (!toolkit || !toolSlugs.length) return null;
  return { toolSlugs, toolkit };
}

export function parseEnableExternalToolsOutput(output: unknown): EnableExternalToolsOutput | null {
  const parsed = enableExternalToolsOutputSchema.safeParse(output);
  if (!parsed.success) return null;

  const toolkit = parsed.data.toolkit.trim().toLowerCase();
  const toolSlugs = [...new Set(parsed.data.toolSlugs.map(slug => slug.trim()).filter(Boolean))];
  return { status: parsed.data.status, toolSlugs, toolkit };
}
